import { EntityType } from '@frontend/common';

/**
 * Builds parent ids for a SLOT badge from colli current-location fields.
 */
export function buildSlotParentIds(input: { spotId?: string | null; moduleId?: string | null }): Record<string, string> | undefined {
    const parents: Record<string, string> = {};
    if (input.spotId) {
        parents.spot_id = input.spotId;
    }
    if (input.moduleId) {
        parents.module_id = input.moduleId;
    }
    return Object.keys(parents).length > 0 ? parents : undefined;
}
